import { Grid } from "@material-ui/core";
import MaterialTable from "material-table";
import React from "react";
import { cellS, headerB } from "../../../St/comps/cStyle";

import { useStylesContainers } from "../../../St/comps/UseStyle";
import { useTranslation } from "react-i18next";
function getItemFromOptions(id, options) {
  if (id) return options.filter((g) => g.id == id)[0];
  return "";
}
const SalesPersonTable = (props) => {
  const { data, onShow } = props;
  const { t } = useTranslation(["forms", "translation"]);
  const clsConts = useStylesContainers();
  const columns = [
    { title: t("no"), field: "id" },
    { title: t("salesman-name"), field: "name" },
    { title: t("commission"), field: "comm" },
    { title: t("email"), field: "email" },
    { title: t("phone-number"), field: "tel" },
    { title: t("mobile-number"), field: "mobile" },
    { title: t("notes"), field: "notes" },
  ];

  function onRowClickHandle(data1) {
    onShow(data1, "edit");
  }
  return (
    <Grid item container lg={12} md={12} className={[clsConts.rootdown]}>
      <Grid
        item
        container
        xs={12}
        className={[clsConts.subDown, clsConts.subDownC]}
      >
        <Grid item xs={12}>
          <MaterialTable
            style={{ boxShadow: "none" }}
            title=""
            // variant="outlined"
            options={{
              pageSize: 7,
              //showTitle:false,
              toolbar: false,
              sorting: false,
              showTitle: false,
              paging: false,

              headerStyle: headerB,
              cellStyle: cellS,
              maxBodyHeight: "65vh",
              minBodyHeight: "65vh",
            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h3
                    style={{
                      marginTop: "20vh",
                      border: "solid 0px",
                      boxShadow: "none",
                    }}
                  ></h3>
                ),
              },
            }}
            columns={columns}
            data={data}
            onRowClick={(event, rowData) => {
              onRowClickHandle(rowData);
              event.preventDefault();
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SalesPersonTable;
